/**
 * @file components/ThemedApp.js
 * @description Wrapper that applies theme colors (accent, background, text)
 * as CSS custom properties so all child components inherit them.
 */
import React from 'react';
import { useTheme } from '../hooks/useTheme';

function ThemedApp({ children }) {
  const { theme } = useTheme();

  const style = {
    '--accent-color': theme.accentColor,
    '--bg-color': theme.backgroundColor,
    '--text-color': theme.textColor,
    '--text-secondary': theme.textSecondary || '#666666',
    '--border-color': theme.borderColor || '#E5E5E5',
    backgroundColor: theme.backgroundColor,
    color: theme.textColor,
    minHeight: '100vh'
  };

  return <div style={style}>{children}</div>;
}

export default ThemedApp;
